import api from './api';

export const customerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `customer/register/${body.channel}`,
        body
      })
    }),
    login: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/login',
        body
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        method: 'POST',
        url: 'customer/logout'
      }),
    }),
    changeRestaurant: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/changeRestaurant',
        body,
      }),
      invalidatesTags: ['MenuCategory'],
    }),
    forgottenPassword: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/forgottenPassword',
        body
      })
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/resetPassword',
        body
      })
    }),
    validatePasswordReset: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/validateResetPasswordCode',
        body
      })
    }),
    guestLogin: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/guestLogin',
        body
      })
    }),
    updateGuestDetails: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/updateGuestDetails',
        body
      })
    }),
    request2FA: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `customer/request2FA/${body.channel}`,
        body
      })
    }),
    validate2FA: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/validate2FA',
        body
      })
    }),
    emailOptIn: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/emailOptIn',
        body,
      })
    }),
    mobileUpdate: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/mobileUpdate',
        body,
      })
    }),
    updateCustomer: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/updateCustomer',
        body,
      })
    }),
    authenticateBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'customer/authenticateBasket',
        body,
      })
    }),
    getAddressesFromPostcode: builder.query({
      query: ({ postcode }) => `geo/LookupAddresses/${postcode}`
    }),
    acceptCookies: builder.query({
      query: () => 'customer/acceptcookies',
    }),
    getAllRewards: builder.query({
      query: () => 'customer/getallrewards',
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useRegisterUserMutation,
  useLoginMutation,
  useForgottenPasswordMutation,
  useResetPasswordMutation,
  useValidatePasswordResetMutation,
  useGuestLoginMutation,
  useRequest2FAMutation,
  useValidate2FAMutation,
  useEmailOptInMutation,
  useMobileUpdateMutation,
  useUpdateCustomerMutation,
  useUpdateGuestDetailsMutation,
  useLogoutMutation,
  useAuthenticateBasketMutation,
  useLazyGetAddressesFromPostcodeQuery,
  useLazyAcceptCookiesQuery,
  useChangeRestaurantMutation,
  useGetAllRewardsQuery
} = customerApi;